import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import LogoutIcon from '@mui/icons-material/Logout';
import { useAuth } from '../../hooks/useAuth';

export default function Header() {
  const { user, logout } = useAuth();

  return (
    <Box
      component="header"
      sx={{
        height: 56,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: 3,
        borderBottom: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.default',
        flexShrink: 0,
      }}
    >
      <Box display="flex" alignItems="center" gap={1.5}>
        <Box
          component="img"
          src="/assets/faana-logo.png"
          alt="Faana"
          sx={{ width: 28, height: 28 }}
        />
        <Typography variant="h5" color="text.primary">
          Faana Portal
        </Typography>
      </Box>

      <Box display="flex" alignItems="center" gap={2}>
        <Typography variant="body2" color="text.secondary">
          {user?.email}
        </Typography>
        <Button
          size="small"
          startIcon={<LogoutIcon />}
          onClick={logout}
          sx={{ color: 'text.secondary' }}
        >
          Sign out
        </Button>
      </Box>
    </Box>
  );
}
